;(function() {
  'use strict'

  Controller.$inject = ["ResponseFilter", "filterSetService", "responseFilterService", "glToast"];
  angular.module('app.core').component('surveyExplorerFilterDialog', {
    controller: Controller,
    templateUrl: 'survey-explorer-filter-dialog.html',
    bindings: {
      channels: '<',
      datapack: '<',
      dashboard: '<',
      filters: '<',
      onDone: '&',
      onCancel: '&',
    },
  })

  /* @ngInject */
  function Controller(
    ResponseFilter,
    filterSetService,
    responseFilterService,
    glToast
  ) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.isDoneDisabled = isDoneDisabled
    ctrl.done = done
    ctrl.cancel = cancel

    function onInit() {
      // set title
      ctrl.title = ctrl.filters.length ? 'Edit Filter' : 'Create Filter'

      // init survey
      ctrl.survey = ctrl.datapack.survey

      // init filter
      if (ctrl.filters.length) {
        console.log('clone')
        ctrl.filters = ctrl.filters.map(function(filter) {
          filter = filter.clone()
          filter.survey = ctrl.survey
          return filter
        })
      } else {
        console.log('new')
        ctrl.filters.push(new ResponseFilter(ctrl.survey).init())
      }

      // gather dimensions
      ctrl.dimensions = {
        system: {},
        report: {},
      }
      for (const key in ctrl.datapack.mappings) {
        if (key.startsWith('srd_')) {
          var bits = key.split('_')
          bits.shift() // srd
          bits.pop() // value
          var label = bits.join('_')
          if (label.startsWith('tag:')) continue // these have their own filter
          if (label === 'link') continue // these have their own filter
          if (label === 'channel') continue // these have their own filter
          var values = Object.values(ctrl.datapack.mappings[key])
          ctrl.dimensions.system[label] = values
        }
        if (key.startsWith('crd_')) {
          var bits = key.split('_')
          bits.shift() // crd
          bits.pop() // value
          var label = bits.join('_')
          if (label.startsWith('tag:')) continue // these have their own filter
          if (label === 'link') continue // these have their own filter
          if (label === 'channel') continue // these have their own filter
          var values = Object.values(ctrl.datapack.mappings[key])
          ctrl.dimensions.report[label] = values
        }
      }

      // ctrl.channels = ctrl.report.channels
      // ctrl.dimensions = responseFilterService.extractDimensionsFromReport(
      //   ctrl.report
      // )
      // ctrl.isReadOnly =
      //   ctrl.filterSet.isReadOnly || !ctrl.report.options.canEditFilters
      // ctrl.visibilityOptions = [
      //   {
      //     label: 'Public (Shared Reports/Dynamic Reports)',
      //     value: false,
      //   },
      //   {
      //     label: 'Private (Glow Account Holders)',
      //     value: true,
      //   },
      // ]
      // ctrl.dialogTitle =
      //   (ctrl.isReadOnly ? 'View' : ctrl.filterSet.isNew() ? 'Add' : 'Edit') +
      //   ' Filter'
      // ctrl.tabs = [
      //   { label: 'Filter', value: 'filter' },
      //   { label: 'Charts', value: 'charts' },
      // ]
      // if (ctrl.filterSet.canEditVisibility()) {
      //   ctrl.tabs.push({
      //     label: 'Visibility',
      //     value: 'visibility',
      //   })
      // }
    }

    function isDoneDisabled() {
      return _.some(ctrl.filters, function(filter) {
        return !filter.validate(true)
      })
    }

    function setModified() {
      ctrl.filterSet.modified = true
    }

    function done() {
      ctrl.onDone({ $filters: ctrl.filters })
      // if (ctrl.filterSet.isSaving) return
      // if (!ctrl.filterSet.validate()) {
      //   glToast.show('Please complete the filter before saving.')
      //   return
      // }

      // filterSetService
      //   .save(ctrl.filterSet)
      //   .then(function() {
      //     ctrl.onSave()
      //   })
      //   .catch(function() {
      //     glToast.show('Error saving filter.')
      //   })
    }

    function cancel() {
      ctrl.onCancel()
    }
  }
})()
